import { FC, ReactElement } from 'react';
import { ButtonBase } from '@material-ui/core';
import cx from 'classnames';

import styles from './index.module.scss';

type ButtonOutlinedProps = {
	title: string;
	clickHandler: () => void;
	parentClassName?: string;
	icon?: ReactElement;
	isDisableLastChildMargin?: boolean;
	disabled?: boolean;
};
const ButtonOutlined: FC<ButtonOutlinedProps> = ({
	title,
	clickHandler,
	parentClassName,
	icon,
	isDisableLastChildMargin = false,
	disabled = false,
}: ButtonOutlinedProps) => {
	return (
		<ButtonBase
			type="button"
			disabled={disabled}
			className={cx(styles.outlined, parentClassName, {
				[styles.outlined__disableLastChildMargin]: isDisableLastChildMargin,
				[styles.disabled]: disabled,
			})}
			onClick={disabled ? undefined : clickHandler}
		>
			{icon || null}
			<span>{title}</span>
		</ButtonBase>
	);
};

export default ButtonOutlined;
